export interface CreateStripeSession {
    //
    prodId: string;
    /**
     * If no couponId is provided, they will then be able to enter one on the check page
     */
    couponId?: string;
    //
    organizationId: string;
    appId: string;
    //
    cancelPath: string;
    successPath: string;
    // optional,
    noTrial?: string;
}

export interface CreateBillingPortalSession {
    /**
     * The application ID
     */
    appId: string;
    /**
     * Where the user will go if they click back
     */
    returnPath?: string;
}
